import React from "react";
import CloseSvg from "./../../../components/svgComponents/CloseSvg";

const CloseModalButton = ({ closeModal }) => {
  return (
    <button
      type="button"
      onClick={closeModal}
      className="w-[30px] h-[30px] md:w-10 md:h-10 rounded-lg flex items-center justify-center hover:bg-[#f0f4ff] bg-white border border-deepBlue shadow-maxButtonShadow dark:bg-[#1D1C2D] dark:hover:!bg-[#36345F]"
    >
      <CloseSvg />
    </button>
  );
};

export default CloseModalButton;
